'use strict';

const $sectionVisualSlide = document.querySelector('.section-visual-slide');
if ($sectionVisualSlide) {
  let option = {
    type: 'loop',
    focus: 'center',
    fixedWidth: '66.3893333333%',
    gap: '0.3rem',
    speed: 400,
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    interval: 3000,
    arrows: false,
    pagination: false,
    drag: true,
    mediaQuery: 'min',
    breakpoints: {
      750: {
        fixedWidth: '66.8055555555%',
        gap: '1rem'
      },
      1440: {
        fixedWidth: '962px',
        gap: '1rem'
      }
    }
  };
  new Splide($sectionVisualSlide, option).mount();
};